import React from 'react';
import { CardLabel, FunButton, FunCard, GameHero, Lottie, Pill } from './GameUI';

const CONFETTI_MS = 2000;

const REFLECT_TOPICS = [
  { emoji: '✍️', text: 'Corrections' },
  { emoji: '📚', text: 'New words' },
  { emoji: '🗣️', text: 'Tricky sounds' },
];

class GameComplete extends React.Component {
  state = { confettiComplete: false };

  componentDidMount() {
    this.timer = setTimeout(() => this.setState({ confettiComplete: true }), CONFETTI_MS);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  headline() {
    return this.props.endReason === 'time_up' ? "Time's up!" : 'Well done!';
  }

  renderConfetti() {
    return (
      <div className="gpConfetti">
        <span className="gpConfetti__emoji" aria-hidden="true">
          {this.props.endReason === 'time_up' ? '⏰' : '🎉'}
        </span>
        <h1 className="gpConfetti__title">{this.headline()}</h1>
        <Lottie src={this.props.lotties.confetti} className="gpConfetti__lottie" />
      </div>
    );
  }

  renderComplete() {
    const score = this.props.score || 0;
    return (
      <div className="gpSplit gpSplit--complete">
        <div className="gpSplit__hero">
          <GameHero
            centered
            emoji="🏆"
            kicker={this.headline().toUpperCase()}
            title={this.props.title || 'Game complete'}
          >
            <div className="gpScoreBadge">
              <span className="gpScoreBadge__number">{score}</span>
              <span className="gpScoreBadge__label">{score === 1 ? 'picture' : 'pictures'} found together</span>
            </div>
          </GameHero>
        </div>

        <div className="gpSplit__main">
          <FunCard entranceIndex={1} className="gpReflect">
            <Lottie src={this.props.lotties.ninja} loop className="gpReflect__ninja" />
            <CardLabel emoji="🥷" text="Well done! Time to reflect." className="gpReflect__label" />
            <p className="gpSubtitle gpReflect__body">Talk through what you learned with your partner.</p>
            <div className="gpReflect__topics">
              {REFLECT_TOPICS.map((topic) => (
                <Pill key={topic.text} emoji={topic.emoji} text={topic.text} />
              ))}
            </div>
          </FunCard>

          <FunButton emoji="🔁" text="Play again" onClick={this.props.onPlayAgain} />
          <FunButton
            variant="soft"
            emoji="🎮"
            text="Back to games"
            onClick={this.props.onBackToGames}
            className="gpSpaceTop"
          />
        </div>
      </div>
    );
  }

  render() {
    return this.state.confettiComplete ? this.renderComplete() : this.renderConfetti();
  }
}

export default GameComplete;
